import React from "react";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { aboutStaffServiceService } from "../services/aboutStaffService";
import { Link } from "react-router-dom";
import { setStaffId } from "../store/Action/staff-action";
import { useDispatch } from "react-redux";
import Historyinabout from "./History in about/Historyinabout";
import Loader from "./Common/Loader";

import img1 from "../../src/assets/img/1.png";
import img2 from "../../src/assets/img/2.png";
import img3 from "../../src/assets/img/3.png";
import img4 from "../../src/assets/img/4.png";
import img5 from "../../src/assets/img/5.png";
import img6 from "../../src/assets/img/6.png";
import img7 from "../../src/assets/img/7.png";
import img8 from "../../src/assets/img/8.png";

import img9 from "../../src/assets/img/9.png";
import img10 from "../../src/assets/img/10.png";
import img11 from "../../src/assets/img/11.png";
import img12 from "../../src/assets/img/12.png";
import img13 from "../../src/assets/img/13.png";
import img14 from "../../src/assets/img/14.png";
import img15 from "../../src/assets/img/15.png";
import img16 from "../../src/assets/img/16.png";

import img17 from "../../src/assets/img/17.png";
import img18 from "../../src/assets/img/18.png";
import img19 from "../../src/assets/img/19.png";
import img20 from "../../src/assets/img/20.png";
import img21 from "../../src/assets/img/21.png";
import img22 from "../../src/assets/img/22.png";
import img23 from "../../src/assets/img/23.png";
import img24 from "../../src/assets/img/24.png";
import img25 from "../../src/assets/img/25.png";
import img26 from "../../src/assets/img/26.png";
const About = () => {
  const dispatch = useDispatch();
  const [staffDataList, setstaffDataList] = useState("");
  const [loading, setLoading] = useState(false);


const operationsTeam = staffDataList?.Operations_Team || [];



const firstRow = operationsTeam.filter(
  (item) => item.landingPage.exist === false || item.landingPage.exist === "false"
);

const secondRow = operationsTeam.filter(
  (item) => item.landingPage.exist === true || item.landingPage.exist === "true"
);







  useEffect(() => {
    setLoading(true);
    // debugger;
    aboutStaffServiceService.getStaffDetails((res) => {
      setLoading(false);
      console.log(res);
      if (res && res.data !== undefined) {
        if (res && res.data && res.data.status === 200) {
          // setstaffDataList(res.data.ResponseObject);

setstaffDataList(
            {
   
    
        "Operations_Team": [
            {
                "post_id": 317,
                "landingPage": { "exist": "true",
                    "title": "DR. ANAND PARIHAR",
                    "altTitle": "Dr. Anand Parihar",
                    "designation": "MD, DMRD, Post-Doctoral Fellow MD Anderson Cancer Center",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/alp.jpg",
                    "dynamicUrl": "staff-page/dr-anand-parihar"
                }
            },
            {
                "post_id": 62317,
                "landingPage": { "exist": "false",
                    "title": "Late Mrs. Veena Parikh",
                    "altTitle": "Late Veena Parikh",
                    "designation": "",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/Mrs.+Veena+Parikh.png",
                    "dynamicUrl": ""
                }
            },
            {
                "post_id": 62319,
                "landingPage": { "exist": "false",
                    "title": "Late Dr. Mandakini Parihar",
                    "altTitle": "Late Dr. Mandakini Parihar",
                    "designation": "",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/Late+Dr.+Mandakini+Parihar.jpg",
                    "dynamicUrl": ""
                }
            },
            {
                "post_id": 62328,
                "landingPage": { "exist": "true",
                    "title": "Mrs. Rupande Shah",
                    "altTitle": "Mrs Rupande Shah",
                    "designation": "Architect",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/Rupande+Shah.png",
                    "dynamicUrl": ""
                }
            },
            {
                "post_id": 62329,
                "landingPage": { "exist": "true",
                    "title": "Mrs. Anuradha Shah",
                    "altTitle": "Mrs. Anuradha Shah",
                    "designation": "Architect",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/Mrs.+Anuradha+Shah.jpeg",
                    "dynamicUrl": ""
                }
            }
        ],
        "Copewithcancer_Volunteer": [
            {
                "post_id": 8496,
                "landingPage": { "exist": "true",
                    "title": "Mrs. SHOBHNA IYER",
                    "altTitle": "Mrs. SHOBHNA IYER",
                    "designation": "PSYCHOLOGIST",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/shobha.jpg",
                    "dynamicUrl": "staff-page/shobhna-iyer"
                }
            },
            {
                "post_id": 13074,
                "landingPage": { "exist": "true",
                    "title": "Mrs. VANDANA MAHAJAN",
                    "altTitle": "Mrs. Vandana Mahajan",
                    "designation": "CANCER CARE AND PALLIATIVE CARE COUNSELOR",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/vandana.jpg",
                    "dynamicUrl": "staff-page/vandana-mahajan"
                }
            },
            {
                "post_id": 13081,
                "landingPage": { "exist": "true",
                    "title": "Mrs. HEMA PRASAD",
                    "altTitle": "Mrs. Hema Prasad",
                    "designation": "VOLUNTEER",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/hema.jpg",
                    "dynamicUrl": "staff-page/hema-prasad"
                }
            },
            {
                "post_id": 13082,
                "landingPage": { "exist": "true",
                    "title": "Mrs. E K SOMAVATHY",
                    "altTitle": "Mrs. E K Somavathy",
                    "designation": "Graduate in Arts",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/somavathy.jpg",
                    "dynamicUrl": "staff-page/e-k-somavathy"
                }
            },
            {
                "post_id": 13426,
                "landingPage": { "exist": "true",
                    "title": "Mrs. PREETI CHANDAN",
                    "altTitle": "Mrs. Preeti Chandan",
                    "designation": "VOLUNTEER",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/preeti.jpg",
                    "dynamicUrl": "staff-page/preeti-chandan"
                }
            },
            {
                "post_id": 61252,
                "landingPage": { "exist": "true",
                    "title": "Mr. RUSHVA PARIHAR",
                    "altTitle": "Mr. Rushva Parihar",
                    "designation": "COMMUNICATIONS COORDINATOR",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/rushva.jpg",
                    "dynamicUrl": "staff-page/rushva-parihar"
                }
            }
        ],
        "Advisory_Board": [
            {
                "post_id": 18719,
                "landingPage": { "exist": "true",
                    "title": "DR. TAPAN SAIKIA",
                    "altTitle": "Dr. Tapan Saikia",
                    "designation": "MBBS, MD (MEDICINE), DM (ONCOLOGY)",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/tapan.jpg",
                    "dynamicUrl": "staff-page/dr-tapan-saikia"
                }
            },
            {
                "post_id": 18720,
                "landingPage": { "exist": "true",
                    "title": "DR. VANI PARMAR",
                    "altTitle": "Dr. Vani Parmar",
                    "designation": "CHIEF OF BREAST SERVICES",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/Dr-Vani-Parmar.png",
                    "dynamicUrl": "staff-page/dr-vani-parmar"
                }
            },
            {
                "post_id": 18721,
                "landingPage": { "exist": "true",
                    "title": "DR. SANGEETA PIKALE",
                    "altTitle": "Dr. Sangeeta Pikale",
                    "designation": "MD .DGO.FCPS.LLB",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/sangeeta.jpg",
                    "dynamicUrl": "staff-page/dr-sangeeta-pikale"
                }
            },
            {
                "post_id": 18722,
                "landingPage": { "exist": "true",
                    "title": "DR. ANITA PATEL",
                    "altTitle": "Dr. Anita Patel",
                    "designation": "CONSULTANT UROLOGIST",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/anita.jpg",
                    "dynamicUrl": "staff-page/dr-anita-patel"
                }
            },
            {
                "post_id": 18723,
                "landingPage": { "exist": "true",
                    "title": "DR. AJIT MENON",
                    "altTitle": "Dr. Ajit Menon",
                    "designation": "CARDIOLOGIST",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/ajit.jpg",
                    "dynamicUrl": "staff-page/dr-ajit-menon"
                }
            },
            {
                "post_id": 18724,
                "landingPage": { "exist": "true",
                    "title": "DR. ANIL BRADOO",
                    "altTitle": "Dr. Anil Bradoo",
                    "designation": "CONSULTANT UROLOGIST MS, MCH, DNB, FRCS-UROLOGY (LONDON)",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/anil.jpg",
                    "dynamicUrl": "staff-page/dr-anil-bradoo"
                }
            },
            {
                "post_id": 18725,
                "landingPage": { "exist": "true",
                    "title": "Mr. SHYAM SHANKAR",
                    "altTitle": "Shyam Shankar",
                    "designation": "A SUPPLY CHAIN LEADER ",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/shyam.jpg",
                    "dynamicUrl": "staff-page/shyam-shankar"
                }
            },
            {
                "post_id": 18726,
                "landingPage": { "exist": "true",
                    "title": "Mrs. Dipa Dwarkadas",
                    "altTitle": "Mrs Dipa Dwarkadas",
                    "designation": "Financial Consultant & Philanthropist",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/dipa.jpg",
                    "dynamicUrl": "staff-page/dipa-dwarkadas"
                }
            },
            {
                "post_id": 18728,
                "landingPage": { "exist": "true",
                    "title": "Mr. ISH CHOWDHARY",
                    "altTitle": "Ish Chowdhary",
                    "designation": "Entrepreneur in the IT sector",
                    "imageUrl": "https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/ish.jpg",
                    "dynamicUrl": "staff-page/ish-chowdhary"
                }
            }
        ],
        "Past_Volunteers": []
    
}
          );
        }
      }
    });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Madat Trust&#039;s Cope with cancer Initiative</title>
        <meta
          name="description"
          content="An Initiative to help patients and caregivers cope with cancer In India."
        />
        <meta name="robots" content="noodp" />
        <link rel="canonical" href="https://www.copewithcancer.org/about-us" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Madat Trust&#039;s Cope with cancer Initiative"
        />
        <meta
          property="og:description"
          content="An Initiative to help patients and caregivers cope with cancer In India."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/about-us"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta
          property="og:image"
          content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/DrMandakinismall.jpg"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="An Initiative to help patients and caregivers cope with cancer In India."
        />
        <meta
          name="twitter:title"
          content="Madat Trust&#039;s Cope with cancer Initiative"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta
          name="twitter:image"
          content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/DrMandakinismall.jpg"
        />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2015-07-30T14:47:00+00:00" />
      </Helmet>
      <div className="topspace">
        <div className="text-center text-center bannerBgColor">
          <div className="aboutus">
            <div className="bannertitleNew mediabannertitleNew">About Us</div>
          </div>
          {/* <img
            src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/aboutus_banner.jpg"
            alt="Cope with Cance"
            className="w-100 imgOpacityInner"
          ></img> */}
          <h1 class="bannertitle displayNone">ABOUT US</h1>
        </div>
        <div className="contentBox">
          <div class="container">
            <div className="row">
              <div className="col-md-6">
                <p className="displayNone">About Us</p>
                <p className="Regular14 mb10"> Who We Are</p>
                <p className="Bold28">
                  We Help Patients And Caregivers Cope With Cancer
                </p>
                <div className="float-left floatNone">
                  <img
                    src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/DrMandakinismall.jpg"
                    alt="DrMandakinismall"
                    className="textwithImg"
                  ></img>
                  <p className="Bold14">Dr. Mandakini Parihar</p>
                </div>
                <p>
                  The website{" "}
                  <strong>
                    <Link className="urlLinkRgular" to="/">
                      www.copewithcancer.org
                    </Link>
                  </strong>{" "}
                  for the initiative &#8220;cope with cancer&#8221; an online
                  &amp; tele-counseling service was launched in July 2013, in
                  memory of Dr Mandakini Parihar who succumbed to Leukaemia in
                  September 2012.
                </p>
                <p>
                  During her illness she and her family felt that there was
                  inadequate information about resources for cancer patients and
                  caregivers and a need for counseling.
                </p>
                <p>
                  After her demise, her family decided to start &#8220;cope with
                  cancer&#8221; with specific emphasis on the needs of the
                  caregivers.
                </p>
                <p>
                  The trust identifies and helps address underserved areas in
                  cancer care in India, thus helping patients and caregivers
                  cope with cancer.
                </p>
                <p>
                  For access to{" "}
                  <span className="Bold14">
                    Mandakini&#8217;s Memorial website{" "}
                  </span>
                  <Link
                    className="urlLinkRgular"
                    to="http://www.forevermissed.com/mandakini-parihar/#about"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click Here
                  </Link>
                </p>
              </div>
              <div className="col-md-6 mt36">
                <h2 class="Bold28">Cancer NGO in Mumbai, India</h2>
                <iframe
                  className="videoYoutube media100 mediaMB40"
                  title="CWC General Activities - 2022"
                  width="1170"
                  height="658"
                  src="https://www.youtube.com/embed/hVwBeUopIJc?feature=oembed&amp;hd=1;rel=0;showinfo=0&amp;controls=2&amp;theme=light&amp;modestbranding=1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Historyinabout />
        </div>

        <div className="grayBg">
          <div className="container">
            <div className="contentSection">
              <div className=" text-center mb30">
                <p className="title">Our Esteemed Donors</p>
                <div className="divider"></div>
                <div className="donerSmallText mb20 mt30">
                  We, at Madat Charitable Trust extend our deepest gratitude to
                  our esteemed donors for their unwavering support. Their
                  generous contributions have enabled us to provide vital
                  medical assistance for chemotherapy, radiation therapy, target
                  therapy, surgery, BMT, cancer medicines, diagnostic tests, ICU
                  support, PICC lines support and genetic testing to thousands
                  of patients in need.
                  <br />
                  <br />
                  We are extremely grateful to all the donors; individuals &
                  corporates for their continued faith in our mission and for
                  making an immediate difference in patient's lives.
                </div>
                <p className="title">Principal Donors</p>
                <div className="divider"></div>
                <div className="row doners mt30">
                  <div className="col-md-2">
                    <img className="mb20" src={img1} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img2} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img3} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img4} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img5} alt={""}></img>
                  </div>
                </div>
                <div className="row doners">
                  <div className="col-md-2">
                    <img className="mb20" src={img6} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img7} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img8} alt={""}></img>
                  </div>
                  
                </div>
                <p className="title mt20">Other Donors</p>
                <div className="divider"></div>
                <div className="row doners mt30">
                  <div className="col-md-2">
                    <img className="mb20" src={img9} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img10} alt={""}></img>
                  </div>

                  {/* <div className="col-md-2">
                    <img className="mb20" src={img11} alt={""}></img>
                  </div> */}
                  <div className="col-md-2">
                    <img className="mb20" src={img12} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img13} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img14} alt={""}></img>
                  </div>
               
                </div>
                <div className="row doners">
                     <div className="col-md-2">
                    <img className="mb20" src={img15} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img16} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img17} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img18} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mb20" src={img19} alt={""}></img>
                  </div>
                  
                 
                  {/* <div className="col-md-2">
                    <img className="mbottom" src={img23} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mbottom" src={img24} alt={""}></img>
                  </div> */}
                </div>
                <div className="row doners">
                  <div className="col-md-2">
                    <img className="mbottom" src={img20} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img className="mbottom" src={img21} alt={""}></img>
                  </div>
                  {/* <div className="col-md-2 mt20">
                    <img className="mb20" src={img25} alt={""}></img>
                  </div> */}
                   <div className="col-md-2">
                    <img className="mbottom" src={img22} alt={""}></img>
                  </div>
                  <div className="col-md-2">
                    <img  src={img26} alt={""}></img>
                  </div>                
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="contentSection">
            {/* <div className=" text-center mb30">
              <p className="title">Trustees</p>
              <div className="divider"></div>
            </div> */}
         <div className="container">

 {/* Present Trustees */}
  <div className=" text-center mb30">
              <p className="title">Past Trustees</p>
              <div className="divider"></div>
            </div>

<div className="row justify-content-center">
  {firstRow.map((item, index) => (
    <div key={index} className="col-md-3 text-center mediaMB20">
      <div className="imgFixbox1">
        <figure className="cardFigure">
          <img
            className="cardImg"
            src={item.landingPage.imageUrl}
            alt={item.landingPage.altTitle}
          />
        </figure>

        <h3>
          <Link className="medium16 threeLineTitleNew">
            {item.landingPage.title}
          </Link>
        </h3>

        <span className="sd-staff-position">
          {item.landingPage.designation}
        </span>

        {item.landingPage.dynamicUrl && (
          <Link
            className="threeLineTitle urlLinkRgular"
            to={`/${item.landingPage.dynamicUrl}`}
            state={item.post_id}
            onClick={() => dispatch(setStaffId(item.post_id))}
            title={item.landingPage.title}
          >
            <p className="urlLinkRgular btn p0 mt15">
              View Profile <i className="fa-solid fa-arrow-right"></i>
            </p>
          </Link>
        )}
      </div>
    </div>
  ))}
</div>

{/* Past Trustees */}

  <div className=" text-center mb30 mt30">
              <p className="title">Present Trustees</p>
              <div className="divider"></div>
            </div>

<div className="row justify-content-center">
  {secondRow.map((item, index) => (
    <div key={index} className="col-md-3 text-center mediaMB20">
      <div className="imgFixbox1">
        <figure className="cardFigure">
          <img
            className="cardImg"
            src={item.landingPage.imageUrl}
            alt={item.landingPage.altTitle}
          />
        </figure>

        <h3>
          <Link className="medium16 threeLineTitleNew">
            {item.landingPage.title}
          </Link>
        </h3>

        <span className="sd-staff-position">
          {item.landingPage.designation}
        </span>

        {item.landingPage.dynamicUrl && (
          <Link
            className="threeLineTitle urlLinkRgular"
            to={`/${item.landingPage.dynamicUrl}`}
            state={item.post_id}
            onClick={() => dispatch(setStaffId(item.post_id))}
            title={item.landingPage.title}
          >
            <p className="urlLinkRgular btn p0 mt15">
              View Profile <i className="fa-solid fa-arrow-right"></i>
            </p>
          </Link>
        )}
      </div>
    </div>
  ))}
</div>

</div>
           
          </div>
        </div>

        <div className="grayBg">
          <div className="container">
            <div className="contentSection">
              <div className=" text-center mb30">
                <p className="title">Advisory Board</p>
                <div className="divider"></div>
                {/* <div>
                  Dr. Anand Parihar and Ms. Urvija Sanghvi work with a committed
                  team of volunteers to accomplish Cope with Cancer's goals and
                  mission.
                </div> */}
              </div>

              <div class="row ">
                {(staffDataList.Advisory_Board || []).map((item, index) => (
                  <div className="col-md-3 text-center mb30">
                    <div className="imgFixbox1">
                      <figure>
                        <img
                          className="cardImg"
                          src={item.landingPage.imageUrl}
                          alt={item.landingPage.altTitle}
                        ></img>
                      </figure>
                      <h3>
                        <Link
                          className="medium16 threeLineTitleNew"
                          // to={`/${item.landingPage.dynamicUrl}`}
                          // state={item.post_id}
                          // onClick={() => {
                          //   console.log(item.post_id);
                          //   dispatch(setStaffId(item.post_id));
                          // }}
                          // title={item.landingPage.title}
                        >
                          {item.landingPage.title}
                        </Link>
                      </h3>
                      <span class="sd-staff-position">
                        {item.landingPage.designation}
                      </span>
                      <Link
                        className=" threeLineTitle"
                        to={`/${item.landingPage.dynamicUrl}`}
                        state={item.post_id}
                        onClick={() => {
                          console.log(item.post_id);
                          dispatch(setStaffId(item.post_id));
                        }}
                        title={item.landingPage.title}
                      >
                        <p
                          class="urlLinkRgular btn p0 mt15"
                          title={item.landingPage.title}
                        >
                          {" "}
                          View Profile <i class="fa-solid fa-arrow-right"></i>
                        </p>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="contentSection">
            <div className=" text-center mb30">
              <p className="title">Copewithcancer Volunteer's Team</p>
              <div className="divider"></div>
              <div>
                {/* Dr. Anand Parihar works with a committed
                team of volunteers to accomplish Cope with Cancer's goals and
                mission. */}
                {/* Dr. Anand Parihar and Ms. Urvija Sanghvi work with a committed
                team of volunteers to accomplish Cope with Cancer's goals and
                mission. */}
                Dr. Anand Parihar work with a committed
                team of volunteers to accomplish Cope with Cancer's goals and
                mission.
              </div>
            </div>
            <div class="row">
              {(staffDataList.Copewithcancer_Volunteer || []).map(
                (item, index) => (
                  <div className="col-md-3 text-center mb30">
                    <div className="imgFixbox1">
                      <figure>
                        <img
                          className="cardImg"
                          src={item.landingPage.imageUrl}
                          alt={item.landingPage.altTitle}
                        ></img>
                      </figure>
                      <h3>
                        <Link
                          className="medium16 threeLineTitleNew"
                          // to={`/${item.landingPage.dynamicUrl}`}
                          // state={item.post_id}
                          // onClick={() => {
                          //   console.log(item.post_id);
                          //   dispatch(setStaffId(item.post_id));
                          // }}
                          // title={item.landingPage.title}
                        >
                          {item.landingPage.title}
                        </Link>
                      </h3>
                      <span class="sd-staff-position">
                        {item.landingPage.designation}
                      </span>
                      <Link
                        className=" threeLineTitle mt15"
                        to={`/${item.landingPage.dynamicUrl}`}
                        state={item.post_id}
                        onClick={() => {
                          console.log(item.post_id);
                          dispatch(setStaffId(item.post_id));
                        }}
                        title={item.landingPage.title}
                      >
                        <p
                          class="urlLinkRgular btn p0 "
                          title={item.landingPage.title}
                        >
                          {" "}
                          View Profile <i class="fa-solid fa-arrow-right"></i>
                        </p>
                      </Link>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
